(function() {
    'use strict';
    
a3_cabin_reports.controller('AdditionalTrainingModalCtrl', AdditionalTrainingModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AdditionalTrainingModalCtrl
    * @description 
    *  Manages Additional Training Modal
    * @ngInject
    */
function AdditionalTrainingModalCtrl($scope, $uibModalInstance, retVal) {

        $scope.ok = ok;
		$scope.cancel = cancel;
            
        if (retVal) {
            $scope.startAdd = true;
		} else {
            $scope.startAdd = false;
		}
        /**
         * Close modal after confirm
         * @memberof AdditionalTrainingModalCtrl
         */
        function ok() {
			$uibModalInstance.close(null);
		}

        /**
         * Close Modal
         * @memberof AdditionalTrainingModalCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();
